module.exports = __webpack_public_path__ + "img/bazaar.d890a1b.png";